// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"fe01e058","172":"8977f9a0","193":"4cac35c7","223":"e8cc5262","677":"dc56ad23","860":"ca607aa9","861":"168bd6b7","963":"3c3892a6"}[chunkId] + ".chunk.js";
};